const serverAdress = 'wss://prog2vk2.cs.uni-saarland.de:8081';
const taskAdress = 'https://prog2vk2.cs.uni-saarland.de:8082/api/tasks/';

export {
    serverAdress,
    taskAdress,
};